<template>
  <b-modal
    id="modal-temp-tracker"
    ref="modal-temp-tracker"
    centered
    :title="$t('liveView.tempTracking.title')"
    size="lg"
    @show="onShow"
    @hide="onHide"
  >
    <b-form>
      <b-row>
        <b-col sm="12" md="6">
          <b-form-group
            class="my-3 mt-4"
            :label="$t('liveView.tempTracking.linkName')"
            label-for="linkName"
            label-class="required"
          >
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0 my-2">
              <b-form-input id="linkName" v-model="form.linkName" type="text" required />
            </b-input-group>
            <span v-if="!linkNameRequired" class="text-danger text-sm-italic">{{
              $t('global.validation.required')
            }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
          <b-form-group
            class="my-3 mt-4"
            :label="$t('liveView.tempTracking.duration')"
            label-for="duration"
            label-class="required"
          >
            <b-row>
              <b-col sm="12" md="6">
                <b-input-group class="mb-2 mr-sm-2 mb-sm-0 my-2">
                  <b-form-input
                    id="duration"
                    v-model="form.duration"
                    type="text"
                    trim
                    :formatter="integerFormatter"
                    required
                  />
                </b-input-group>
                <span v-if="!durationRequired" class="text-danger text-sm-italic">{{
                  $t('global.validation.required')
                }}</span>
              </b-col>
              <b-col sm="12" md="6">
                <b-input-group class="mb-2 mr-sm-2 mb-sm-0 my-2">
                  <multiselect
                    v-model="form.durationType"
                    :options="durationTypeOptions"
                    track-by="value"
                    label="label"
                    :placeholder="`${$t('global.form.select')} ${$t(
                      'liveView.tempTracking.duration'
                    )}`"
                  />
                </b-input-group>
                <span v-if="!durationTypeRequired" class="text-danger text-sm-italic">{{
                  $t('global.validation.required')
                }}</span>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group class="my-3" :label="$t('liveView.tempTracking.notes')" label-for="notes">
        <b-input-group class="mb-2 mr-sm-2 mb-sm-0 my-2">
          <b-form-input
            id="notes"
            v-model="form.notes"
            :placeholder="$t('liveView.tempTracking.notes')"
            type="text"
            required
          />
        </b-input-group>
      </b-form-group>
      <div class="mt-4 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h5 class="m-0">
            {{ $t('liveView.tempTracking.vehicleText') }}
          </h5>
          <i id="tooltip-info" class="mc-fa icon-outline_info ms-1" style="font-size: 16px"> </i>
          <b-tooltip target="tooltip-info" triggers="hover" placement="topLeft">
            {{ $t('liveView.tempTracking.vehicleTooltip') }}
          </b-tooltip>
        </div>
        <a v-if="isActiveAll" class="link-primary" @click="inActiveAll()">
          {{ $t('global.action.nonactivate') }}
        </a>
        <a v-if="!isActiveAll" class="link-primary" @click="activeAll()">
          {{ $t('global.action.activate') }}
        </a>
      </div>
      <b-card>
        <div v-for="opt in listOptions" :key="`option-${opt.id}`" class="my-3">
          <div class="row align-items-center">
            <div class="col-md-6">
              <p class="m-0">
                {{ opt.title }}
              </p>
            </div>
            <div class="col-md-6 align-self-end">
              <div class="float-end">
                <div class="form-check form-switch form-switch-md">
                  <input
                    v-model="cekNonaktif[opt.model]"
                    class="form-check-input"
                    type="checkbox"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <span v-if="!atLeastOneActive" class="text-danger text-sm-italic">{{
          $t('liveView.tempTracking.atLeastActive')
        }}</span>
      </b-card>
    </b-form>
    <template #modal-footer="{ cancel }">
      <b-button size="md" variant="outline-primary" @click="cancel()">
        {{ $t('global.action.cancel') }}
      </b-button>
      <b-button size="md" variant="primary" :disabled="!isValidModal" @click="saveForm()">
        {{ $t('global.action.save') }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { Helper } from '@/mixin/helper'
import Multiselect from 'vue-multiselect'
import { CREATE_TRACKING_TEMPORARY } from '@/services/api/trackingTemporary/temporary'

export default {
  components: {
    Multiselect,
  },
  mixins: [Helper],
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    vehicleId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      form: {
        linkName: '',
        duration: 1,
        durationType: {
          value: 'Hari',
          label: this.$t('global.time.days'),
        },
        notes: '',
      },
      cekNonaktif: {
        driverName: true,
        lastSeen: true,
        speed: true,
        temperature: true,
        engineStatus: true,
      },
      baseUrl: window.location.origin,
    }
  },
  computed: {
    listOptions() {
      return [
        {
          id: 1,
          title: this.$t('liveView.option.driverName'),
          model: 'driverName',
        },
        {
          id: 2,
          title: this.$t('liveView.option.lastSeen'),
          model: 'lastSeen',
        },
        {
          id: 3,
          title: this.$t('liveView.option.speed'),
          model: 'speed',
        },
        {
          id: 4,
          title: this.$t('liveView.option.temperature'),
          model: 'temperature',
        },
        {
          id: 5,
          title: this.$t('liveView.option.engineStatus'),
          model: 'engineStatus',
        },
      ]
    },
    durationTypeOptions() {
      return [
        {
          value: 'Menit',
          label: this.$t('global.time.minutes'),
        },
        {
          value: 'Jam',
          label: this.$t('global.time.hours'),
        },
        {
          value: 'Hari',
          label: this.$t('global.time.days'),
        },
        {
          value: 'Minggu',
          label: this.$t('global.time.weeks'),
        },
        {
          value: 'Bulan',
          label: this.$t('global.time.months'),
        },
      ]
    },
    linkNameRequired() {
      return (
        this.form.linkName != '' && this.form.linkName != null && this.form.linkName != undefined
      )
    },
    durationRequired() {
      return (
        this.form.duration != '' &&
        this.form.duration != null &&
        this.form.duration != undefined &&
        parseInt(this.form.duration) > 0
      )
    },
    durationTypeRequired() {
      return (
        this.form.durationType != '' &&
        this.form.durationType != null &&
        this.form.durationType != undefined
      )
    },
    atLeastOneActive() {
      return (
        this.cekNonaktif.driverName ||
        this.cekNonaktif.lastSeen ||
        this.cekNonaktif.speed ||
        this.cekNonaktif.temperature ||
        this.cekNonaktif.engineStatus
      )
    },
    isValidModal() {
      return (
        this.linkNameRequired &&
        this.durationRequired &&
        this.durationTypeRequired &&
        this.atLeastOneActive
      )
    },
    isActiveAll() {
      return (
        this.cekNonaktif.driverName &&
        this.cekNonaktif.lastSeen &&
        this.cekNonaktif.speed &&
        this.cekNonaktif.temperature &&
        this.cekNonaktif.engineStatus
      )
    },
  },
  methods: {
    resetForm() {
      this.form = {
        linkName: '',
        duration: 1,
        durationType: {
          value: 'Hari',
          label: this.$t('global.time.days'),
        },
        notes: '',
      }
      this.cekNonaktif = {
        driverName: true,
        lastSeen: true,
        speed: true,
        temperature: true,
        engineStatus: true,
      }
    },
    onHide() {
      this.resetForm()
    },
    saveForm() {
      const duration = this.durationToMinutes(this.form.duration, this.form.durationType.value)
      const picked = []
      Object.keys(this.cekNonaktif).forEach((item) => {
        if (this.cekNonaktif[item] === true) {
          picked.push(item)
        }
      })
      let input = {
        duration: duration,
        name: this.form.linkName,
        note: this.form.notes,
        vehicleIds: [this.vehicleId],
        pickedColumns: picked,
      }
      this.$apollo
        .mutate({
          mutation: CREATE_TRACKING_TEMPORARY,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.createTemporaryLiveView.isSuccessful) {
            const accessToken = response.data.createTemporaryLiveView.temporaryLiveView.accessToken
            const shortKey = response.data.createTemporaryLiveView.temporaryLiveView.shortKey
            const temporaryLvId =
              response.data.createTemporaryLiveView.temporaryLiveView.temporaryLvId
            const res = {
              accessToken,
              temporaryLvId,
              shortKey,
            }

            const link = `${this.baseUrl}/fleet/live-track/${temporaryLvId}?shToken=${shortKey}`
            navigator.clipboard.writeText(link)
            this.$mcToast.success(this.$t('global.alert.text.linkCopied'))

            this.$emit('setAccessToken', res)
            this.resetForm()
            this.$bvModal.show('modal-temp-tracker-result')
            this.$bvModal.hide('modal-temp-tracker')
          } else {
            this.isSubmit = false
            return this.$mcToast.error(response.data.createTemporaryLiveView.message)
          }
        })
    },
    inActiveAll() {
      this.cekNonaktif = {
        driverName: false,
        lastSeen: false,
        speed: false,
        temperature: false,
        engineStatus: false,
      }
    },
    activeAll() {
      this.cekNonaktif = {
        driverName: true,
        lastSeen: true,
        speed: true,
        temperature: true,
        engineStatus: true,
      }
    },
    onShow() {
      this.form.linkName = `Pelacakan Sementara (${this.licensePlate})`
    },
  },
}
</script>
